import React from 'react';
import { FormGroup, FormControl, ControlLabel } from 'react-bootstrap';
import PropTypes from 'prop-types';

const ViewStaff = ({ access, item }) => (
  <>
    <FormGroup>
      <ControlLabel htmlFor="subject">Subject</ControlLabel>
      <FormControl
        type="text"
        name="subject"
        id="subject"
        defaultValue={item?.subject || ''}
        disabled={!access?.notifications_edit && !item?.access?.can_edit}
      />
    </FormGroup>
    <FormGroup>
      <ControlLabel htmlFor="body">Body</ControlLabel>
      <FormControl
        defaultValue={item?.body || ''}
        componentClass="textarea"
        className="resize-vertical"
        id="body"
        name="body"
        aria-required="true"
        rows={12}
        cols={30}
        disabled={!access?.notifications_edit && !item?.access?.can_edit}
      />
    </FormGroup>
  </>
);

ViewStaff.propTypes = {
  access: PropTypes.object,
  item: PropTypes.object,
};

export default ViewStaff;
